<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-13 13:42:08
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:57:34
 * @name: 修改人员信息
 * @Description: 修改人员信息
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\dialog\edit-account.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div>
    <addNeditDialog ref="addNeditDialog" title="修改账号" @close="close">
      <template v-slot:form>
        <div class="line">
          <font class="label">人员名称:</font>
          <el-input
            class="input"
            v-model="form.realname"
            placeholder="请输入人员名称"
          ></el-input>
        </div>
        <div class="line">
          <font class="label">联系电话:</font>
          <el-input
            class="input"
            v-model="form.mobile"
            placeholder="请输入联系电话"
          ></el-input>
        </div>
      </template>
      <template v-slot:btnGroup>
        <el-button class="submit" type="primary" @click="submit"
          >确认</el-button
        >
      </template>
    </addNeditDialog>
  </div>
</template>
<script>
import addNeditDialog from "@/components/pianoCompanyManage/dialog/addNeditDialog.vue";
import { debounceation } from '@/utils/decorator';

export default {
  name: "pianoCompanyManage-addAccount",
  components: {
    addNeditDialog,
  },
  data() {
    return {
      id: "",
      form: {
        realname: "",
        mobile: "",
      },
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化data
     */
    initData() {
      this.id = "";
      this.form = {
        realname: "",
        mobile: "",
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Object} childRow 子表格操作行数据
     */
    open(childRow) {
      this.id = childRow.id || "";
      this.form.realname = childRow.realname || "";
      this.form.mobile = childRow.mobile || "";
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗回调
     */
    close() {
      this.initData();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)   
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确认
     */    
    @debounceation(300)
    submit() {
      this.$emit("editAccount", { id: this.id, form: this.form });
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 100%;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
  }
  .input {
    flex: 1;
  }
  .text {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
  }
}
.submit {
  width: $Var-button-width-normal;
}
</style>
